import i18n from '../language/index'
export function getErrorRes(code, mess) {
    let params = ''
        // 地址簿异常
    if (code === 1013001001) {
        params = i18n.t("addressBook.errorTip")
    } // 地址簿为空
    else if (code === 1013001002) {
        params = i18n.t("updateNewSip.emptyBookTip")
    } // 地址簿加密密码为空
    else if (code === 1013001003) {
        params = i18n.t("updateNewSip.errorSecret")
    }
    return params
}